import React, { useEffect, useRef, useState } from "react";
import { loadGoogleMaps, COMPANY_HQ_ADDRESS } from "@/lib/googleMaps";
import { Clock, Navigation } from "lucide-react";

export default function SiteRouteMap({ lat, lng }) {
  const mapRef = useRef(null);
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!lat || !lng) return;
    let cancelled = false;
    loadGoogleMaps().then((maps) => {
      if (cancelled || !mapRef.current) return;
      const map = new maps.Map(mapRef.current, {
        center: { lat, lng }, zoom: 11, disableDefaultUI: true, zoomControl: true,
      });
      const renderer = new maps.DirectionsRenderer({ map, suppressMarkers: false });
      const svc = new maps.DirectionsService();
      svc.route({
        origin: COMPANY_HQ_ADDRESS,
        destination: { lat, lng },
        travelMode: maps.TravelMode.DRIVING,
      }, (result, status) => {
        if (cancelled) return;
        if (status === "OK") {
          renderer.setDirections(result);
          const leg = result.routes[0].legs[0];
          setInfo({ duration: leg.duration.text, distance: leg.distance.text });
        } else { setError(true); }
      });
    }).catch(() => setError(true));
    return () => { cancelled = true; };
  }, [lat, lng]);

  if (!lat || !lng) return null;

  return (
    <div className="rounded-lg overflow-hidden border border-slate-200">
      <div ref={mapRef} style={{ height: 220, width: "100%" }} />
      <div className="p-2 bg-slate-50 flex items-center gap-4 text-xs text-slate-600">
        {info ? (<>
          <span className="flex items-center gap-1"><Clock className="w-3 h-3 text-orange-500" />{info.duration}</span>
          <span className="flex items-center gap-1"><Navigation className="w-3 h-3 text-orange-500" />{info.distance}</span>
          <span className="text-slate-400">dalla sede di Pedriano</span>
        </>) : error ? (
          <span className="text-slate-400">Percorso non disponibile</span>
        ) : (
          <span className="text-slate-400">Calcolo percorso...</span>
        )}
      </div>
    </div>
  );
}
